var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5553 7.74256C14.5128 7.58219 14.4273 7.42737 14.2929 7.29292L7.70711 0.707131C7.07714 0.0771658 6 0.523332 6 1.41424V7.00002H2C0.895431 7.00002 0 7.89545 0 9.00002V20C0 21.1046 0.89543 22 2 22H13C14.1046 22 15 21.1046 15 20V9.00002C15 8.52361 14.8334 8.0861 14.5553 7.74256Z",
    fill: "#2674FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestIcon);
export default __webpack_public_path__ + "static/media/bestIcon.7874876d491db9dea8278336c46a845f.svg";
export { ForwardRef as ReactComponent };